import {
  convertToDayJs,
  getCurrentTimeDiff,
} from 'shared/src/utils/date-utils';

/** 24시간 이상이면 'N일', 미만이면 'HH:MM:SS' 포맷 */
const DAY_FORMAT_THRESHOLD_SECOND = 24 * 60 * 60;

export type CountdownDisplay = {
  /** 롤링 대상 문자열 ('HH:MM:SS' 또는 'N일'). suffix('남음')는 표시부에서 붙임 */
  text: string;
  isExpired: boolean;
};

const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);

export const computeCountdownDisplay = (
  finishedAt: string,
): CountdownDisplay => {
  const remainSecond = -getCurrentTimeDiff(convertToDayJs(finishedAt), 'second');

  // 파싱 실패(NaN 등) 또는 만료: 숨기지 않고 '00:00:00' 정지 상태로 노출
  if (!Number.isFinite(remainSecond) || remainSecond <= 0) {
    return { text: '00:00:00', isExpired: true };
  }
  if (remainSecond >= DAY_FORMAT_THRESHOLD_SECOND) {
    return { text: `${Math.ceil(remainSecond / 86400)}일`, isExpired: false };
  }
  const hour = Math.floor(remainSecond / 3600);
  const minute = Math.floor((remainSecond % 3600) / 60);
  const second = remainSecond % 60;
  return {
    text: `${pad(hour)}:${pad(minute)}:${pad(second)}`,
    isExpired: false,
  };
};
